
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"60","height":"35","x":"10","y":"10","fill":"#308BE5","rx":"6"}}),_c('rect',{attrs:{"width":"60","height":"20","x":"10","y":"50","fill":"#71B7FD","rx":"6"}}),_c('rect',{attrs:{"width":"40","height":"15","x":"20","y":"20","fill":"#A8D1FA","rx":"6"}}),_c('path',{attrs:{"fill":"#023E92","d":"M51.68 37.07l-15.6-10.8s-3.3-1.99-4.34-1c-1.39.5-1.73 4-1.73 4v18.42c-.18 4.32 2.6 4.98 2.6 4.98a2.8 2.8 0 002.08-.5c.7-.5 1.56-1.82 1.56-1.82l1.9-4.32L42.33 53c2.43 3.33 4.86 1.5 4.86 1.5.34-.17 2.77-1.16 1.56-4.65l-3.47-7.3 4.85 1s1.74.16 2.43 0c.7-.17 1.22-.67 1.74-1.34.17-.16 1.21-2.65-2.6-5.14z"}})])
          )
        }
      }
    